import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { PipesModule } from '@cbcore/pipes/pipes.module';
import { UnitsDistributionBase } from '../base/units-distribution.base';

@Component({
    selector: 'ud-fantasy-margin',
    templateUrl: './fantasy-spread/fantasy-spread.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, TranslocoModule, PipesModule]
})
export class FantasyMarginComponent extends UnitsDistributionBase {
  override getUnits(distribution: any): number {
    return super.getUnits(distribution);
  }
}